import React, { Component } from "react";

import PropTypes from "prop-types";
import axios from "axios";

export class TeamItem extends Component {
  state = {
    imgUrl: "",
    imgUrlTh: "",
    imgUrlMd: "",
    imgUrlLg: "",
    imgUrlMdLg: "",
    imgUrl600: "",
    imgUrl900: "",
    isLoaded: false,
  };
  static propTypes = {
    team: PropTypes.object.isRequired,
  };

  componentDidMount() {
      //@ts-ignore
    const { featured_media } = this.props.team;
    const getImageUrl = axios.get(`https://obrien365.com/ob-wp/wp-json/wp/v2/media/${featured_media}`);

    Promise.all([getImageUrl]).then((res) => {
      console.log(res);
      this.setState({
        imgUrl: res[0].data.media_details.sizes.full.source_url,
        imgUrlTh: res[0].data.media_details.sizes.thumbnail.source_url,
        imgUrlMd: res[0].data.media_details.sizes.medium.source_url,
        imgUrlLg: res[0].data.media_details.sizes.large.source_url,
        imgUrlMdLg: res[0].data.media_details.sizes.medium_large.source_url,
        imgUrl600: res[0].data.media_details.sizes.ob600.source_url,
        imgUrl900: res[0].data.media_details.sizes.ob900.source_url,
        isLoaded: true,
      });
    });
  }

  render() {
      //@ts-ignore
    const { slug, title, content, acf } = this.props.team;
    const { imgUrl, imgUrlMd, imgUrlLg, imgUrlMdLg, imgUrl600, imgUrl900, isLoaded } = this.state;
    if (isLoaded) {
      return (
        <section id={slug} className="ob-home-team">
          
          <div className="team">
            <img src={imgUrl} srcSet={ imgUrlMd + ' 300w, ' + imgUrlLg + ' 1024w, ' + imgUrlMdLg + ' 768w, ' + imgUrl600 + ' 630w, ' + imgUrl900 + ' 960w'} alt={title.rendered} />
            <div className="team-title"><h3 dangerouslySetInnerHTML={{ __html: title.rendered }}></h3></div>
          </div>
          
        </section>
      );
    }
    return null;
  }
}

export default TeamItem;
